/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.connected.application.status.rpc.frontend.ConnectedStatusGraphQLService
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type VoidResponse = {};

export type LocalisedCta = { message: string; link?: string };

export type ConnectedStatusError = {
  errorType: ConnectedStatusErrorType;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type ConnectedStatusErrorType =
  | 'BATCH_LIMIT_EXCEEDED'
  | 'DUPLICATE'
  | 'LINGUINE_ERROR'
  | 'NOT_FOUND'
  | 'NO_STATUS_CONDITIONS_CONFIG_FOUND'
  | 'INSERT_ERROR'
  | 'MISSING_CONNECTED_STATUS_IDENTIFIER'
  | 'SPACE_IN_IDEMPOTENCY_ID'
  | 'NO_STATUS_CONDITION_CONFIG_FOUND'
  | 'IDEMPOTENCY_ID_TOO_LONG'
  | 'PORTAL_NOT_FOUND_IN_CURRENT_HUBLET'
  | 'PORTALS_NOT_FOUND_IN_CURRENT_HUBLET'
  | 'INVALID_STATUS_TYPE'
  | 'APPLICATION_FETCH_ERROR'
  | 'NAMESPACE_NOT_FOUND'
  | 'EMPTY_NAMESPACE'
  | 'EMPTY_NAMESPACES'
  | 'INACTIVE_NAMESPACE'
  | 'INVALID_NAMESPACE'
  | 'STATUS_TYPE_NOT_DISMISSABLE'
  | 'ID_OUT_OF_RANGE'
  | unhandledEnumCase;

export type ConnectedStatusResponse = {
  results: Default<LocalisedConnectedStatus[]>;
  total: Default<number>;
};

export type ConnectedStatusResponseV3 = {
  results: Default<LocalisedConnectedStatusV3[]>;
  total: Default<number>;
};

export type DismissStatusBatchRequest = {
  requests: Default<DismissStatusRequest[]>;
};

export type DismissStatusRequest = {
  appId: number;
  namespace: string;
  statusType: string;
  cause?: string;
  businessUnitId?: number;
  externalAccountId?: string;
  unifiedAccountId?: number;
};

export type LocalisedConnectedStatus = {
  appId: number;
  userId?: number;
  businessUnitId?: number;
  externalAccountId?: string;
  unifiedAccountId?: number;
  status: string;
  type: string;
  cause?: string;
  cta: LocalisedCta;
  metadata: StatusMetadata;
};

export type LocalisedConnectedStatusV3 = {
  portalId: number;
  namespace: string;
  appId: number;
  userId?: number;
  businessUnitId?: number;
  externalAccountId?: string;
  unifiedAccountId?: number;
  status: string;
  type: string;
  cause?: string;
  cta: LocalisedCta;
  metadata: StatusMetadata;
};

export type StatusFetchOptions = {
  appIds: Default<number[]>;
  externalAccountIds: Default<string[]>;
  userIds: Default<number[]>;
  businessUnitIds: Default<number[]>;
  statusTypes: Default<string[]>;
  categories: Default<StatusTypeCategory[]>;
  includeAllNamespaceStatuses: Default<boolean>;
};

export type StatusGraphQLFetchRequest = {
  locale?: string;
  statusFetchOptions: Default<StatusFetchOptions>;
};

export type StatusMetadata = {
  severity: StatusSeverity;
  category: StatusTypeCategory;
  ctaButtonText: string;
  hollowStyle: boolean;
  createdAt: number;
  updatedAt: number;
};

export type StatusSeverity =
  | 'DEFAULT'
  | 'SUCCESS'
  | 'WARNING'
  | 'DANGER'
  | 'INFO'
  | unhandledEnumCase;

export type UserStatusFetchOptionsV3 = {
  appIds: Default<number[]>;
  businessUnitIds: Default<number[]>;
  externalAccountIds: Default<string[]>;
  unifiedAccountIds: Default<number[]>;
  namespaces: Default<string[]>;
  statusTypes: Default<string[]>;
  categories: Default<StatusTypeCategory[]>;
  includeAllNamespaceStatuses: Default<boolean>;
};

export type UserStatusGraphQLFetchRequestV3 = {
  locale?: string;
  statusFetchOptions: Default<UserStatusFetchOptionsV3>;
};

export type StatusTypeCategory =
  | 'AUTHORIZATION'
  | 'NOTIFICATION'
  | unhandledEnumCase;

export type FetchRequestType = Requestify<StatusGraphQLFetchRequest>;
export type FetchResponseType = ConnectedStatusResponse;
export type FetchErrorType = ConnectedStatusError & HubspotMetadata;
export const fetchRpc: ChirpAvroRpcDetails<
  FetchRequestType,
  FetchResponseType,
  FetchErrorType,
  false
> = {
  serviceName:
    'com.hubspot.connected.application.status.rpc.frontend.ConnectedStatusGraphQLService',
  rpcName: 'fetch',
  auth: 'app',
  fingerprint: 'mdFQJXEaVZ8yMPhfqOGnCcYHw8MyCaa6',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type FetchAllForUserRequestType =
  Requestify<UserStatusGraphQLFetchRequestV3>;
export type FetchAllForUserResponseType = ConnectedStatusResponseV3;
export type FetchAllForUserErrorType = ConnectedStatusError & HubspotMetadata;
export const fetchAllForUserRpc: ChirpAvroRpcDetails<
  FetchAllForUserRequestType,
  FetchAllForUserResponseType,
  FetchAllForUserErrorType,
  false
> = {
  serviceName:
    'com.hubspot.connected.application.status.rpc.frontend.ConnectedStatusGraphQLService',
  rpcName: 'fetchAllForUser',
  auth: 'app',
  fingerprint: 'qNzI1F3FmcDJDB5U9l5yUMYHw8MyCaa6',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type DismissBatchRequestType = Requestify<DismissStatusBatchRequest>;
export type DismissBatchResponseType = VoidResponse;
export type DismissBatchErrorType = ConnectedStatusError & HubspotMetadata;
export const dismissBatchRpc: ChirpAvroRpcDetails<
  DismissBatchRequestType,
  DismissBatchResponseType,
  DismissBatchErrorType,
  false
> = {
  serviceName:
    'com.hubspot.connected.application.status.rpc.frontend.ConnectedStatusGraphQLService',
  rpcName: 'dismissBatch',
  auth: 'app',
  fingerprint: 'HlLTLzK2oUC-dVpgiofIycYHw8MyCaa6',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type DismissBatchForUserRequestType =
  Requestify<DismissStatusBatchRequest>;
export type DismissBatchForUserResponseType = VoidResponse;
export type DismissBatchForUserErrorType = ConnectedStatusError &
  HubspotMetadata;
export const dismissBatchForUserRpc: ChirpAvroRpcDetails<
  DismissBatchForUserRequestType,
  DismissBatchForUserResponseType,
  DismissBatchForUserErrorType,
  false
> = {
  serviceName:
    'com.hubspot.connected.application.status.rpc.frontend.ConnectedStatusGraphQLService',
  rpcName: 'dismissBatchForUser',
  auth: 'app',
  fingerprint: 'HlLTLzK2oUC-dVpgiofIycYHw8MyCaa6',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
